// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;
// state:'disabled' for disabled link
// state:'block' for visable & clickable link

const navConfig = [
 
  {
    title: 'Sub category',
    path: '/files/all-subcategory/',
    icon: getIcon('eva:arrowhead-right-outline'),
    state: 'block',
  },


  {
    title: ' Work scopes',
    path: '/files/all-scopes',
    icon: getIcon('eva:arrowhead-right-outline'),
    state: 'block',
  },

  // {
  //   title: 'Graphic artists',
  //   path: '#',
  //   icon: getIcon('eva:color-palette-outline'),
  //   state: 'block',
  // },
];

export default navConfig;
